@if (stakeholderName != null) {
  <span>{{stakeholderName}}&nbsp;</span>
}
@if (notifyStakeholder) {
  <div class="dx-icon-email notify-stakeholder" title="Notify stakeholder"></div>
}
@if (isUrgent) {
  <div class="dx-icon-runner is-urgent" title="Is urgent"></div>
}
@if (notifySender) {
  <div class="dx-icon-email notify-sender" title="Notify sender"></div>
}
@if (notifyReceiver) {
  <div class="dx-icon-email notify-receiver" title="Notify receiver"></div>
}